export const within_30_minute_running_time = `상영 시작까지 30분 이내인 영화입니다.|결제가 늦을 경우 예매가 불가능하니,|예매 양식 전달 후 바로 결제 부탁드립니다.`;
export const default_next_page_message = `결제 완료된 순서대로 예매가 진행됩니다.|아직 결제를 완료하지 않은 상태라면,|예매 양식 전달 후 바로 결제 부탁드립니다.`;
